import { CustomViewType } from '../../Compounds/CustomTableViews/helpers';
import { SchedulerInline } from '../../Compounds/CustomTableViews/SchedulerInline';
import { useSavedViews } from '../../Compounds/CustomTableViews/useSavedViews';
import { viewNameFromKey, viewTypeOf } from '../../Compounds/CustomTableViews/viewKey';
import { ScheduleSetting, useScheduleSettings } from '../../../store/ScheduleSettings';
import { getUser } from '../../../store/User';

export interface EditReportFormProps {
  schedule: ScheduleSetting;
  onClose: () => void;
  onChanged: () => void;
  onDeleted: (id: string) => void;
}

/** The scheduler the grids use, on a report you own, with the saved views of its grid to combine as tabs. */
export const EditReportForm = ({ schedule, onClose, onChanged, onDeleted }: EditReportFormProps) => {
  const { saveSchedule, deleteSchedule, optOut, resume } = useScheduleSettings();
  const type = viewTypeOf(schedule.view_key) as CustomViewType;
  const projectId = schedule.project_id ?? undefined;
  const [views] = useSavedViews(type, projectId);
  const currentUser = getUser();

  const availableViews = views.map((view) => {
    const viewKey = `${type}_grid_${view.name}`;
    return { viewKey, name: viewNameFromKey(viewKey) };
  });

  return (
    <SchedulerInline
      viewKey={schedule.view_key}
      viewName={schedule.name}
      availableViews={availableViews}
      existingSchedule={schedule}
      currentUserId={currentUser.id}
      currentUserEmail={currentUser.email}
      projectId={projectId}
      onSave={async (payload, existingId, options) => {
        const saved = await saveSchedule(payload, existingId, options);
        if (saved) onChanged();
        return saved;
      }}
      onDelete={async (id) => {
        const deleted = await deleteSchedule(id);
        if (deleted) {
          onDeleted(id);
          onChanged();
        }
        return deleted;
      }}
      onOptOut={optOut}
      onResume={async (id) => {
        const resumed = await resume(id);
        if (resumed) onChanged();
        return resumed;
      }}
      onClose={onClose}
    />
  );
};
